<div class="">
  <ul>
    <li *ngFor="let pathbar of pathbars, let i = index">
      <a [routerLink]="[pathbar.path]" [title]="pathbar.title">{{pathbar.description}} </a>
    </li>
  </ul>
</div>
